import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { InsertStudent } from "../lib/supabase";
import StudentForm from "../components/students/StudentForm";
import SmartBackButton from "../components/ui/SmartBackButton";
import toast from "react-hot-toast";
import { useAuth } from "../contexts/AuthContext";

const AddStudent: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleAddStudent = async (data: InsertStudent) => {
    try {
      setIsLoading(true);

      if (!user) {
        throw new Error("User not authenticated");
      }

      // Use lowercase keys to match the students table schema
      const studentData = {
        codername: data.codername,
        age: data.age,
        parentname: data.parentname,
        email: data.email,
        phone: data.phone,
        run_id: data.run_id,
        user_id: user.id,
        notes: data.notes || null,
        school: data.school || null,
      };

      console.log("Adding student with data:", studentData);

      const { data: newStudent, error } = await supabase
        .from("students")
        .insert([studentData])
        .select()
        .single();

      if (error) {
        console.error("Supabase error details:", error);
        throw error;
      }

      console.log("Student added successfully:", newStudent);

      // If student is enrolled in a run, create a payment record for tracking
      if (data.run_id) {
        // Get the run price to create the payment record
        const { data: runData, error: runError } = await supabase
          .from("runs")
          .select("price")
          .eq("id", data.run_id)
          .single();

        if (runError) {
          console.error("Error fetching run price:", runError);
        } else if (runData) {
          // Create a payment record with amount 0 (not received)
          const { error: paymentError } = await supabase
            .from("payments")
            .insert({
              student_id: newStudent.id,
              run_id: data.run_id,
              amount: 0, // 0 amount indicates payment not received
              payment_method: "stripe", // Default method
              payment_date: new Date().toISOString().split("T")[0],
              notes: "Payment not yet received - student enrolled manually",
            });

          if (paymentError) {
            console.error("Error creating payment record:", paymentError);
            // Don't fail the student creation if payment record fails
            toast.error("Student created but payment tracking record failed");
          }
        }
      }

      toast.success("Student added successfully");
      navigate(`/students/${newStudent.id}`);
    } catch (error) {
      console.error("Error adding student:", error);
      toast.error("Failed to add student");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="flex items-center mb-6">
        <SmartBackButton
          fallbackPath="/students"
          className="text-link hover:text-hover flex items-center"
        />
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-neutral-200 overflow-hidden">
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <h1 className="">Add New Student</h1>
          </div>

          <StudentForm onSubmit={handleAddStudent} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default AddStudent;
